import {createTheme} from '@mui/material/styles';
import {grey} from "@mui/material/colors";

const Theme = createTheme({
    palette: {
        customColor: {
            hwCatalogTabsColor: grey[100],
        },
    },
});

export default Theme;
